export default "__VITE_ASSET__d1e6beea__"